// support for Browserify

require('angular-material');
require('./dist/md-data-table');

module.exports = 'md.data.table';



/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/~/angular-material-data-table/index.js
 ** module id = 203
 ** module chunks = 0
 **/